module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEJSURBVHgB7dfRicJAFAXQu7P7r+kgJWQ7sIXtxGVXf/VbkMEOtAPtQDuwA9PB2IAZn4JgBPUF3gjqPZBAhpfhJkxmJgAREdEr+4A1HzwqdKXntRw/+M1KGHKw5EPnGPYgopCjC2O2gSvktevoWjBmG/gBGDg1Bk7t6QLrFw4fcpm2vNzRvloTj9NaftZSSn2JWyJm+MumUNIHHofNRRg7Dt+yIq51pXptpLLTvwh94AoTpHAYMv/ZXF/exCgUN8ewQ0fOg7OWlTzo8Gp9xBZ93VA4+WpSfLfzsXyYNW6DXmsJQ5yHU2Pg1Bg4tTcP7DCvbXZitYCxFL/5uewNCnxiKRuaLYiIiKiBPYDkNlHsrEjbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus_btn.png
// module id = 0l27
// module chunks = 1